module.exports = __webpack_public_path__ + "img/download.4ecf489b.svg";